export const schemaReports = (value) => {
  return {
    name: value?.name || '',
    description: value?.description || '',
    columns: value?.columns || [],
    filters: value?.filters || [],
  }
}
